module.exports = __webpack_public_path__ + "static/media/template4.6a9ddf53.png";